// Per-module configuration for the shared Large Format estimating engine.
// The ENGINE (LargeFormat.js) reads this config; module-exclusive settings live HERE,
// so tweaking one module never touches the engine or other modules.
export const LF_CONFIG = {
  key: "lf",
  moduleKey: "largeformat",
  saveModule: "Gran Formato",
  sticker: false,
  title: "Large Format",
  subtitle: "Roll media · nesting · tiling · comparison",
  defaultSizes: [{ width: 24, height: 18, qty: 1 }],
  pageTestId: "large-format-page",
};

export const STICKER_CONFIG = {
  key: "sticker",
  moduleKey: "stickers",
  saveModule: "Stickers",
  sticker: true,
  title: "Stickers",
  subtitle: "Kiss-cut · 52×38 sections · layout-driven quantity",
  defaultSizes: [{ width: 3, height: 3, qty: 100 }],
  pageTestId: "stickers-page",
};

export const CONFIG_BY_VARIANT = { lf: LF_CONFIG, sticker: STICKER_CONFIG };
